import { memo, SyntheticEvent } from 'react';
import './button.scss';
import loaderIcon from '../../../assets/images/loader-icon.svg';

export interface ButtonProps {
    variant: string;
    type?: 'submit' | 'reset' | 'button';
    title?: string;
    onClick?: () => void;
    isDisabled?: boolean;
    children: JSX.Element[] | JSX.Element | string;
    isLoading?: boolean;
    cyTestId?: string;
    dataTestId?: string;
}
function Button({ variant, type = 'button', title, onClick, children, isLoading = false, isDisabled = false, cyTestId = '', dataTestId = '' }: ButtonProps) {

    function handleClick(e: SyntheticEvent) {
        if (type !== 'submit') {
            e.preventDefault();
        }
        if (onClick) {
            onClick();
        }
    }

    return (
        <button
            data-cy={cyTestId.split(' ').join('-')}
            className={variant + (isLoading ? ' loading-btn' : '')}
            onClick={handleClick}
            type={type}
            title={title}
            data-testid={dataTestId ? dataTestId : "button"}
            disabled={isLoading || isDisabled}
            role="button"
        >
            <span className="button-content">
                <img className={"loader" + (isLoading ? "" : " hidden")} src={loaderIcon} style={{ opacity: 1, height: '14px', marginRight: '8px' }} />
                {children}
            </span>
        </button>
    );
}

export default memo(Button);